module.exports = __webpack_public_path__ + "static/media/arrow_heading.357723d7.svg";